import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import {
  Row,
  Col
} from 'reactstrap'
import '../css/Store.css'
import PageHeader from './utils/PageHeader'
import { API_URL } from './utils/Constants/URLS'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import AddStore from './Forms/FormComponents/AddStore'

const StoreHome = () => {
  const token = localStorage.getItem('token')
  const userDetails = useSelector(store => store.user)
  const [storeData, setStoreData] = useState([])
  const [storeDemographicData, setStoreDemographicData] = useState({})

  useEffect(() => {
    const getStoreData = async () => {
      const url = `${API_URL}stores`
      const data = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      const result = await data.json()
      setStoreData(result.data.docs)
    }
    getStoreData()
  }, [token])


  useEffect(() => {
    const getStoreDemographic = async () => {
      const url = `${API_URL}stores/demography`
      const data = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      const result = await data.json()
      setStoreDemographicData(result.data)
    }
    getStoreDemographic()
  }, [token])

  return (
    <>
      <PageHeader
        pageName='STORE'
        breadcrump1='Home'
        breadcrump2='Store'
        link='/store_home'
      />
      <div className='p-4'>
        <Row className='mb-4'>
          <Col md='4' sm='6' xs='12' className='mb-3'>
            <div className='info-box d-flex align-items-center'>
              <div className='info-number'>{storeDemographicData?.stores}</div>
              <div className='info-content ms-auto text-end'>
                <div className='info-title'>NUMBER OF STORES</div>
                <i className='bi bi-pc-display icon-style'></i>
              </div>
            </div>
          </Col>
          <Col md='4' sm='6' xs='12' className='mb-3'>
            <div className='info-box d-flex align-items-center'>
              <div className='info-number'>{storeDemographicData?.models}</div>
              <div className='info-content ms-auto text-end'>
                <div className='info-title'>NUMBER OF MODELS</div>
                <i className='bi bi-pc-display icon-style'></i>
              </div>
            </div>
          </Col>
          <Col md='4' sm='6' xs='12' className='mb-3'>
            <div className='info-box d-flex align-items-center'>
              <div className='info-number'>
                {storeDemographicData?.products}
              </div>
              <div className='info-content ms-auto text-end'>
                <div className='info-title'>NUMBER OF PRODUCTS</div>
                <i className='bi bi-box-seam icon-style'></i>
              </div>
            </div>
          </Col>
        </Row>
        {userDetails.role === 'super_admin' || userDetails.role === 'admin' ? (
          <AddStore/>
        ) : (
          ''
        )}

        <Row className='g-4'>
          {storeData.map((data, index) => {
            return (
              <>
                <Col md='3' sm='6' key={index}>
                  <Link to={data?.id} className='no-underline'>
                    <div className={`store-card store-${index + 1}`}>
                      <div className='store-icon'>🏬</div>
                      <div className='store-name'>{data?.name}</div>
                      <div className='manager-name'>
                        Manager: {data?.storeManager?.name}
                      </div>
                    </div>
                  </Link>
                </Col>
              </>
            )
          })}
        </Row>
      </div>
      
    </>
  )
}

export default StoreHome
